module.exports = __webpack_public_path__ + "static/media/logout2.f0c7759b.png";